"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoading = exports.LOADING_Z_INDEX = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const GREY_OPACITY = '#ffffff4d';
exports.LOADING_Z_INDEX = 100;
exports.StyledLoading = styled_components_1.default.div `
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${GREY_OPACITY};
  z-index: ${exports.LOADING_Z_INDEX};
`;
